module.exports = __webpack_public_path__ + "static/telegram-chat-1f26b6f332efa023d4b7d340c1d41cba.svg";